module.exports = __webpack_public_path__ + "static/media/plaza-4.8bdf3850.webp";